import { ClientSpecMapService } from '../sharedServices';
import type { ManifestStore } from '../stores';

export class ManifestLoadingTracker {
  #manifestWaiters = new Map<
    string,
    { promise: Promise<void>; resolve: () => void }
  >();

  constructor(
    private manifestStore: ManifestStore,
    private clientSpecMapService: ClientSpecMapService,
  ) {
    this.manifestStore.onManifestLoaded((compType) => {
      this.#onManifestLoaded(compType);
    });
  }

  isComponentTypesKnown(compTypes: string[]) {
    return this.clientSpecMapService.isComponentTypesKnown(compTypes);
  }

  #onManifestLoaded(compType: string) {
    const waiter = this.#manifestWaiters.get(compType);
    if (waiter) {
      waiter.resolve();
      this.#manifestWaiters.delete(compType);
    }
  }

  waitForManifest(compType: string): Promise<void> {
    const existing = this.#manifestWaiters.get(compType);

    if (existing) {
      return existing.promise;
    }

    let resolve!: () => void;
    const promise = new Promise<void>((res) => {
      resolve = res;
    });

    this.#manifestWaiters.set(compType, { promise, resolve });

    return promise;
  }

  async waitForAllPending(): Promise<void> {
    const pendingPromises = [...this.#manifestWaiters.values()].map(
      (waiter) => waiter.promise,
    );

    await Promise.all(pendingPromises);
  }
}
